import { useMediaQuery } from "react-responsive";

import { isWebView } from "@/constants/webView";

function useViewMode() {
  const isMobile = useMediaQuery({ maxWidth: 745 });
  const isLg = useMediaQuery({ minWidth: 1025 });
  return { isAppMode: isWebView || isMobile, isMobile, isLg };
}

export default useViewMode;
